<template>
  <a
    class="card grid__cell col4-of-12 card--vendor tech--vendor theme-border-base"
  >
    <div class="card__main">
      <div class="card__content">
        <div class="card__image ta-center theme-border-base p-md">
          <img :src="data.image" />
        </div>
        <div class="card__truncate">
          <p class="fw-bold theme-text-dark fs-md mb-xs truncate">
            {{ data.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="card__footer">
      <Button
        v-if="!added"
        v-on:button-click="createPartnership(data.id)"
        bWidth="expanded"
        class="ta-center"
      >
        Add Partner
      </Button>

      <Button
        v-if="added"
        bWidth="expanded"
        class="ta-center mt-3"
        bType="error"
        v-on:button-click="deletePartnership(data.idEntry)"
      >
        Remove Partner
      </Button>
    </div>
  </a>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Button from '@/components/DesignSystem/Button';
const { mapActions } = createNamespacedHelpers('findPartners');

export default {
  props: {
    data: Object,
  },
  components: {
    Button,
  },
  data() {
    return {
      added: false,
    };
  },
  created() {
    if (this.data.idEntry) {
      this.added = true;
    }
  },
  methods: {
    ...mapActions(['removePartner', 'addPartner']),
    createPartnership(id) {
      this.addPartner(id);
      this.added = true;
    },
    deletePartnership(id) {
      this.removePartner(id);
      this.added = false;
    },
  },
};
</script>
